import { centsToReais } from '@doutorsim/shared/helpers/currency'
import type { TExposedPersonDeclarationDTO } from '@doutorsim/shared/exposed/person-declarations'
import type { TExposedPersonOfficialDataDTO } from '@doutorsim/shared/exposed/persons'
import type { RowConfig } from './field-config'

// Money fields cross the UI boundary in cents → reais here so downstream
// cells render human units.
export const officialValueForRow = (
  row: RowConfig,
  data: TExposedPersonOfficialDataDTO | null,
): string | null => {
  if (!data) return null
  if (row.subField) return data.address?.[row.subField] ?? null
  switch (row.question) {
    case 'birth_date':
      return data.birthDate
    case 'mother_name':
      return data.motherName
    case 'income':
      return data.income != null ? String(centsToReais(data.income)) : null
    default:
      return null
  }
}

export const patientValueForRow = (
  _row: RowConfig,
  declaration: TExposedPersonDeclarationDTO | undefined,
): string | null => declaration?.answer ?? null
